/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle very large numbers?`)
};

const es_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Maneja números muy grandes?`)
};

const de_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden auch sehr große Zahlen unterstützt?`)
};

const nl_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan het zeer grote getallen verwerken?`)
};

const fr_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère-t-il les très grands nombres ?`)
};

const it_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisce numeri molto grandi?`)
};

const pt_br2_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele lida com números muito grandes?`)
};

const pt_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trata números muito grandes?`)
};

const ja_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に大きな数に対応していますか？`)
};

const zh_nb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`能处理非常大的数字吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq2_q", locale)
	if (locale === "en") return en_nb_faq2_q(inputs)
	if (locale === "es") return es_nb_faq2_q(inputs)
	if (locale === "de") return de_nb_faq2_q(inputs)
	if (locale === "nl") return nl_nb_faq2_q(inputs)
	if (locale === "fr") return fr_nb_faq2_q(inputs)
	if (locale === "it") return it_nb_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq2_q(inputs)
	if (locale === "pt") return pt_nb_faq2_q(inputs)
	if (locale === "ja") return ja_nb_faq2_q(inputs)
	return zh_nb_faq2_q(inputs)
};